import { faLayerGroup } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function LayerGroupIcon(props) {
  return (
      <Icon
        size="2x"
        transform="down-5"
        {...props}
        icon={faLayerGroup}
      />
  );
}
